const binding = { modules: {}, dataActions: {} };

    (binding.modules['eshop-featured-products'] = {
        c: () => require('partner/modules/eshop-featured-products/eshop-featured-products.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eshop-featured-products',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eshop-featured-products'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eshop-featured-products|eshop-featured-products'] = {
                c: () => require('partner/modules/eshop-featured-products/eshop-featured-products.view.tsx'),
                cn: '__local__-__local__-eshop-featured-products'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };